export default "__VITE_ASSET__wPxLqBMQ__";